var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "action-bar" },
        slot: "action-bar"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-4 col-lg-4 col-xl-4" },
            [
              _c("CardTitleInput", {
                staticClass:
                  "action-header typography--headline typography--title",
                attrs: { "model-value": _vm.card.title },
                on: { input: _vm.applyCardTitle, "has-error": _vm.onHasError }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-8 col-lg-8 col-xl-8 hidden-sm-down" },
            [
              _c(
                "div",
                { staticClass: "action-btn-row" },
                [
                  _c(
                    "MoreBtnDropdown",
                    { staticClass: "float-right" },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          staticClass:
                            "dropdown-item typography--color-secondary",
                          on: {
                            click: function($event) {
                              return _vm.$root.$emit(
                                "show::modal",
                                "delete-my-card-modal"
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.card.menu.remove")))]
                      ),
                      _vm._v(" "),
                      this.isBusanPublisher
                        ? _c(
                            "div",
                            [
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "dropdown-label",
                                  style: { "padding-left": "20px" }
                                },
                                [_c("strong", [_vm._v("부산교육청 메뉴")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function($event) {
                                      return _vm.$root.$emit(
                                        "show::modal",
                                        "export-content"
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                BEST로 내보내기\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary float-right ml-1 mr-1",
                      attrs: { disabled: _vm.saveDisabled || !this.isModified },
                      on: { click: _vm.saveMyCard }
                    },
                    [
                      !_vm.busy
                        ? _c("span", [_vm._v(_vm._s(_vm.$t("common.save")))])
                        : _c("LoadingBounce")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-primary float-right mr-1",
                      on: { click: _vm.openCardPreview }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.preview")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-outline-primary float-right ml-1 mr-1",
                      staticStyle: { padding: "5px 16px" },
                      attrs: { disabled: _vm.saveDisabled },
                      on: {
                        click: function($event) {
                          return _vm.handleMyCardShareSetupClick(
                            _vm.card.id,
                            _vm.card.share_level
                          )
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: "/static/images/ic-hotspot.svg" }
                      }),
                      _vm._v(" "),
                      _vm.card.share_level === 2
                        ? _c("span", [_vm._v("비공개중")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.card.share_level === 1
                        ? _c("span", [_vm._v("전체 공개중")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.card.share_level === 3
                        ? _c("span", [_vm._v("기관 공개중")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.card.share_level === 99
                        ? _c("span", [_vm._v("숨김처리중")])
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-4 pt-1",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              { staticClass: "card-row" },
              [
                _c("Card", { staticClass: "library-detail-card" }, [
                  _c("div", {
                    staticClass: "card-cover-img-thumb",
                    style: _vm.styleBindings
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "card-cover-img-input text-center clickable"
                    },
                    [
                      _c("img", {
                        attrs: { src: "/static/images/ic-camera.svg", alt: "" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "no-display",
                        attrs: {
                          type: "file",
                          accept: "image/png,image/jpeg,image/jpg"
                        },
                        on: { change: _vm.onCoverImageChange }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-block" }, [
                    _c("div", { staticClass: "card-info-section" }, [
                      !_vm.card.subject_id
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 typography--body-3 typography--color-disabled"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "card_details.card_meta.subject_placeholder"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        : _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.subject")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-8" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-primary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.getSubjectLabel(_vm.card)) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ]),
                      _vm._v(" "),
                      _vm.card.grade_id === undefined
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 typography--body-3 typography--color-disabled"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "card_details.card_meta.grade_placeholder"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        : _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.grade")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-8" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-primary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.getGradeLabel(_vm.card)) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ]),
                      _vm._v(" "),
                      !_vm.card.unit_id
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 typography--body-3 typography--color-disabled"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "card_details.card_meta.chapter_placeholder"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.card.unit_id
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.chapter")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-8" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-primary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.card.chapter_name) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.card.core_concept_id === undefined ||
                      _vm.card.core_concept_id === null
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 typography--body-3 typography--color-disabled"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "card_details.card_meta.core_concepts_placeholder"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        : _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t(
                                          "card_details.card_meta.core_concept"
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-8" }, [
                              _vm.isPublisherUser
                                ? _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-primary"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.getCoreConceptLabel(
                                              _vm.coreConcepts[
                                                _vm.card.core_concept_id
                                              ]
                                            ) +
                                              " (" +
                                              _vm.card.core_concept_id +
                                              ")"
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                : _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-primary"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.getCoreConceptLabel(
                                              _vm.coreConcepts[
                                                _vm.card.core_concept_id
                                              ]
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                            ])
                          ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-keywords-section" }, [
                      _vm.card.core_concept_id
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t(
                                          "card_details.card_meta.learning_elements"
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-8" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-primary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.getLearningElements(
                                          _vm.coreConcepts[
                                            _vm.card.core_concept_id
                                          ]
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-action" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-primary btn-block",
                          attrs: { disabled: _vm.isLoadingVideoCourseCard },
                          on: {
                            click: function($event) {
                              return _vm.$root.$emit(
                                "show::modal",
                                "edit-card-modal"
                              )
                            }
                          }
                        },
                        [
                          _vm.isLoadingVideoCourseCard
                            ? [_c("LoadingBounce")]
                            : [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t("card_details.card_meta.edit")
                                    ) +
                                    "\n                "
                                )
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "b-modal",
                        {
                          staticClass: "edit-card-modal",
                          attrs: {
                            id: "edit-card-modal",
                            title: _vm.$t("card_details.card_meta.edit"),
                            "ok-title": _vm.$t("common.save"),
                            "close-title": _vm.$t("common.cancel")
                          },
                          on: {
                            ok: _vm.applySelectedCardInfo,
                            shown: _vm.setupEditCardModal
                          }
                        },
                        [
                          _c("div", { staticClass: "dropdown-group" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-secondary",
                                  attrs: { for: "card-title-input" }
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.title")
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selected.title,
                                    expression: "selected.title"
                                  }
                                ],
                                staticClass: "form-control basic-text-input",
                                attrs: {
                                  type: "text",
                                  id: "card-title-input",
                                  placeholder: _vm.$t(
                                    "card_details.card_meta.title_placeholder"
                                  ),
                                  maxlength: "50"
                                },
                                domProps: { value: _vm.selected.title },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.selected,
                                      "title",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.isPublisherUser
                            ? _c("div", { staticClass: "dropdown-group" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "typography--body-3 typography--color-secondary",
                                        attrs: { for: "card-goal-input" }
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "card_details.card_meta.goal"
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("AutosizeTextarea", {
                                      staticClass:
                                        "form-control basic-text-input",
                                      attrs: {
                                        id: "card-goal-input",
                                        rows: 3,
                                        limit: 5000,
                                        placeholder: _vm.$t(
                                          "card_details.card_meta.goal_placeholder"
                                        )
                                      },
                                      model: {
                                        value: _vm.selected.goal,
                                        callback: function($$v) {
                                          _vm.$set(_vm.selected, "goal", $$v)
                                        },
                                        expression: "selected.goal"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown-group" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-label typography--body-3 typography--color-secondary"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.grade")
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown",
                                {
                                  staticClass: "edit-card-dropdown",
                                  attrs: {
                                    text: _vm.getTranslatedName(
                                      _vm.gradeMap[_vm.selected.grade_id]
                                    )
                                  }
                                },
                                [
                                  _vm._l(_vm.gradeList, function(value, key) {
                                    return _c(
                                      "b-dropdown-item",
                                      {
                                        key: key,
                                        on: {
                                          click: function($event) {
                                            return _vm.selectGrade(
                                              value.id,
                                              value.school_year
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.getTranslatedName(
                                                _vm.gradeMap[value.id]
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.selectGrade(null, "null")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t("common.selects.others")
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown-group" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-label typography--body-3 typography--color-secondary"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.subject")
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown",
                                {
                                  staticClass: "edit-card-dropdown",
                                  attrs: {
                                    id: "subject-dropdown",
                                    text: _vm.getTranslatedName(
                                      _vm.subjectMap[_vm.selected.subject_id]
                                    )
                                  }
                                },
                                _vm._l(_vm.gradeSubjects, function(value, key) {
                                  return _c(
                                    "b-dropdown-item",
                                    {
                                      key: key,
                                      on: {
                                        click: function($event) {
                                          return _vm.selectSubject(value.id)
                                        }
                                      }
                                    },
                                    [
                                      value.id
                                        ? [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.getTranslatedName(
                                                    _vm.subjectMap[value.id]
                                                  )
                                                ) +
                                                "\n                      "
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown-group" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-label typography--body-3 typography--color-secondary"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.chapter")
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown",
                                {
                                  staticClass: "edit-card-dropdown",
                                  attrs: {
                                    text:
                                      _vm.getUnitLabel(
                                        _vm.units[_vm.selected.unit_id]
                                      ) ||
                                      _vm.$t("card_details.card_meta.select"),
                                    id: "unit-dropdown"
                                  }
                                },
                                [
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.selectUnit("9999")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "card_details.card_meta.select"
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.currentUnitList, function(unit) {
                                    return _c(
                                      "b-dropdown-item",
                                      {
                                        key: unit.id,
                                        on: {
                                          click: function($event) {
                                            return _vm.selectUnit(unit.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(_vm.getUnitLabel(unit)) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown-group" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-label typography--body-3 typography--color-secondary"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "card_details.card_meta.core_concept"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown",
                                {
                                  staticClass: "edit-card-dropdown",
                                  attrs: {
                                    text:
                                      _vm.getDetailedCoreConceptLabel(
                                        _vm.coreConcepts[
                                          _vm.selected.core_concept_id
                                        ]
                                      ) ||
                                      _vm.$t("card_details.card_meta.select"),
                                    id: "core-concept-dropdown"
                                  }
                                },
                                [
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.selectCoreConcept("9999")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "card_details.card_meta.select"
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.currentCoreConceptList, function(
                                    coreConcept
                                  ) {
                                    return _c(
                                      "b-dropdown-item",
                                      {
                                        key: coreConcept.id,
                                        attrs: {
                                          title:
                                            _vm.$t(
                                              "card_details.card_meta.learning_elements"
                                            ) +
                                            ": " +
                                            coreConcept.description
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectCoreConcept(
                                              coreConcept.id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.getDetailedCoreConceptLabel(
                                                coreConcept
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "keyword-group" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "keyword-label typography--body-3 typography--color-secondary"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "card_details.card_meta.learning_elements"
                                      )
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "keyword-container" }, [
                              _vm.coreConcepts[_vm.selected.core_concept_id]
                                ? _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-secondary"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.getLearningElements(
                                              _vm.coreConcepts[
                                                _vm.selected.core_concept_id
                                              ]
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                : _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-disabled"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      -\n                    "
                                      )
                                    ]
                                  )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.isPublisherUser
                            ? _c("div", { staticClass: "dropdown-group" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-secondary",
                                      attrs: { for: "video-course-id" }
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$t(
                                                "card_details.card_meta.video_course"
                                              )
                                            ) +
                                            "\n                      "
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selected.video_course_id,
                                        expression: "selected.video_course_id"
                                      }
                                    ],
                                    staticClass:
                                      "form-control basic-text-input",
                                    attrs: {
                                      type: "text",
                                      id: "video-course-id"
                                    },
                                    domProps: {
                                      value: _vm.selected.video_course_id
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.selected,
                                          "video_course_id",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ])
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.pagesReady,
                  expression: "!pagesReady"
                }
              ],
              staticClass: "col-md-8"
            },
            [
              _c(
                "div",
                { staticClass: "card-row" },
                [_c("DummyPageSummary")],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.pagesReady,
                  expression: "pagesReady"
                }
              ],
              staticClass: "col-md-8"
            },
            [
              _c(
                "draggable",
                {
                  on: {
                    start: function($event) {
                      _vm.drag = true
                    },
                    end: function($event) {
                      _vm.drag = false
                    }
                  },
                  model: {
                    value: _vm.card.pages,
                    callback: function($$v) {
                      _vm.$set(_vm.card, "pages", $$v)
                    },
                    expression: "card.pages"
                  }
                },
                _vm._l(_vm.card.pages, function(page, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "card-row" },
                    [
                      _c("MyPageSummary", {
                        attrs: {
                          page: page,
                          card: _vm.card,
                          index: index,
                          "card-title": _vm.card.title
                        },
                        on: {
                          "edit-page": _vm.openPageEditorModal,
                          "remove-page": _vm.openRemovePageModal,
                          "hidden-page": _vm.openHiddenPageModal,
                          "recover-hidden-page": _vm.openRecoverHiddenPageModal,
                          "edit-extra-content": _vm.openEditExtraContentModal
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-row" },
                [_c("PageAddBlock", { staticClass: "hide-tooltip" })],
                1
              )
            ],
            1
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _c(
          "BasicModal",
          {
            attrs: {
              id: "delete-my-card-modal",
              title: _vm.$t("common.modal.remove.title")
            },
            on: { ok: _vm.deleteCard }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("common.modal.remove.message"))
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: {
              id: "delete-my-card-page-modal",
              title: _vm.$t("common.modal.remove.title")
            },
            on: { ok: _vm.removePage, cancel: _vm.cancelRemovePage }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("common.modal.remove.message"))
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: { id: "hidden-my-card-page-modal", title: "숨김" },
            on: { ok: _vm.hiddenPage, cancel: _vm.cancelHiddenPage }
          },
          [
            _c("div", {
              domProps: { innerHTML: _vm._s("페이지를 숨김처리 하시겠습니까?") }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: {
              id: "recover-hidden-my-card-page-modal",
              title: "숨김 처리 복구"
            },
            on: {
              ok: _vm.recoverHiddenPage,
              cancel: _vm.cancelRecoverHiddenPage
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s("페이지를 숨김 상태를 복구하시겠습니까?")
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: { id: "export-content", title: "내보내기" },
            on: { ok: _vm.exportContent }
          },
          [
            _c("div", {
              domProps: { innerHTML: _vm._s("BEST 시스템으로 내보내겠습니까?") }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: {
              id: "make-card-public-modal",
              title: _vm.$t("common.modal.make_public.title")
            },
            on: {
              ok: function($event) {
                return _vm.updateShareLevel(1)
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("common.modal.make_public.message"))
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: {
              id: "make-card-private-modal",
              title: _vm.$t("common.modal.make_private.title")
            },
            on: {
              ok: function($event) {
                return _vm.updateShareLevel(2)
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("common.modal.make_private.message"))
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "no-class-to-assign-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.no_class_to_assign_alert.message")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "empty-card-info-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.empty_card_info.message")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal hide-ok-btn square-area-btn-modal",
            attrs: {
              id: "quiz-type-select-modal",
              title: _vm.$t("card_details.create_page"),
              "close-title": _vm.$t("common.close")
            }
          },
          [
            _c("div", { staticClass: "row square-area-btn-row" }, [
              _c("div", { staticClass: "col-3 square-area-btn-col" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "square-area-btn text-center typography--body-3 typography--color-secondary clickable",
                    on: {
                      click: function($event) {
                        _vm.showNonQuizEditorModal = true
                        _vm.$root.$emit("hide::modal", "quiz-type-select-modal")
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass:
                        "square-area-btn-icon square-area-btn-non-quiz"
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.page_types.non_quiz")) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3 square-area-btn-col" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "square-area-btn text-center typography--body-3 typography--color-secondary clickable",
                    on: {
                      click: function($event) {
                        _vm.showMultipleChoiceEditorModal = true
                        _vm.$root.$emit("hide::modal", "quiz-type-select-modal")
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass:
                        "square-area-btn-icon square-area-btn-multiple-choice"
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.page_types.multiple_choice")) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3 square-area-btn-col" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "square-area-btn text-center typography--body-3 typography--color-secondary clickable",
                    on: {
                      click: function($event) {
                        _vm.showTextEntryEditorModal = true
                        _vm.$root.$emit("hide::modal", "quiz-type-select-modal")
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass:
                        "square-area-btn-icon square-area-btn-text-entry"
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.page_types.text_entry")) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3 square-area-btn-col" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "square-area-btn text-center typography--body-3 typography--color-secondary clickable",
                    on: {
                      click: function($event) {
                        _vm.showEssayTypeEditorModal = true
                        _vm.$root.$emit("hide::modal", "quiz-type-select-modal")
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass:
                        "square-area-btn-icon square-area-btn-essay-type"
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.page_types.essay_type")) +
                        "\n          "
                    )
                  ]
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        !!_vm.pageToEditExtraContent
          ? _c("ExtraContentEditModal", {
              attrs: {
                id: "extra-content-edit-modal",
                page: _vm.pageToEditExtraContent,
                card: _vm.card
              },
              on: { cancel: _vm.cancelPageEdit, ok: _vm.cancelPageEdit }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("PageLibraryModal", { on: { "import-pages": _vm.importPages } }),
        _vm._v(" "),
        _c("PageEditorModal", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showNonQuizEditorModal,
              expression: "showNonQuizEditorModal"
            }
          ],
          attrs: {
            id: "non_quiz-editor-modal",
            "new-page-type": "non_quiz",
            "is-shown": _vm.showNonQuizEditorModal
          },
          on: {
            "page-added": _vm.onPageAdded,
            cancel: function($event) {
              _vm.showNonQuizEditorModal = false
            }
          }
        }),
        _vm._v(" "),
        _c("PageEditorModal", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMultipleChoiceEditorModal,
              expression: "showMultipleChoiceEditorModal"
            }
          ],
          attrs: {
            id: "multiple_choice-editor-modal",
            "new-page-type": "multiple_choice",
            "is-shown": _vm.showMultipleChoiceEditorModal
          },
          on: {
            "page-added": _vm.onPageAdded,
            cancel: function($event) {
              _vm.showMultipleChoiceEditorModal = false
            }
          }
        }),
        _vm._v(" "),
        _c("PageEditorModal", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showTextEntryEditorModal,
              expression: "showTextEntryEditorModal"
            }
          ],
          attrs: {
            id: "text_entry-editor-modal",
            "new-page-type": "text_entry",
            "is-shown": _vm.showTextEntryEditorModal
          },
          on: {
            "page-added": _vm.onPageAdded,
            cancel: function($event) {
              _vm.showTextEntryEditorModal = false
            }
          }
        }),
        _vm._v(" "),
        _c("PageEditorModal", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showEssayTypeEditorModal,
              expression: "showEssayTypeEditorModal"
            }
          ],
          attrs: {
            id: "essay_type-editor-modal",
            "new-page-type": "essay_type",
            "is-shown": _vm.showEssayTypeEditorModal
          },
          on: {
            "page-added": _vm.onPageAdded,
            cancel: function($event) {
              _vm.showEssayTypeEditorModal = false
            }
          }
        }),
        _vm._v(" "),
        _c("PageEditorModal", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showEditPageModal,
              expression: "showEditPageModal"
            }
          ],
          attrs: {
            id: "edit-page-editor-modal",
            page: _vm.currentEditingPage,
            "is-shown": _vm.showEditPageModal
          },
          on: { "page-added": _vm.onPageAdded, cancel: _vm.cancelPageEdit }
        }),
        _vm._v(" "),
        _c("AddVideoModal", { on: { add: _vm.addVideo } }),
        _vm._v(" "),
        _c("MathEditorModal", {
          attrs: { id: "math-editor-modal" },
          on: { add: _vm.addMath }
        }),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal",
            attrs: {
              id: "page-leave-alert",
              "hide-header": true,
              "close-title": _vm.$t("common.cancel"),
              "ok-title": _vm.$t("common.confirm")
            },
            on: { ok: _vm.pageLeaveOk, cancel: _vm.pageLeaveCancel }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.page_leave_alert.message")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _vm.isMyCardShareSetupModal
          ? _c("MyCardShareSetupModal", {
              attrs: {
                cardId: _vm.selectedCardId,
                cardShareLevel: _vm.savedCardShareLevel,
                onModalCancelClick: function() {
                  return (this$1.isMyCardShareSetupModal = false)
                },
                onModalOkClick: _vm.handleCardShareLevelUpdate,
                isLoading: _vm.isLoadingCardShareLevel,
                isPublisher: _vm.isPublisherUser
              }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "hidden-md-up",
        attrs: { slot: "floating-action-menu" },
        slot: "floating-action-menu"
      },
      [
        _c(
          "FloatingDropup",
          [
            _c("b-dropdown-item", { on: { click: _vm.openCardPreview } }, [
              _vm._v(_vm._s(_vm.$t("common.preview")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-divider" }),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              {
                attrs: { disabled: _vm.saveDisabled },
                on: { click: _vm.saveMyCard }
              },
              [_vm._v(_vm._s(_vm.$t("common.save")))]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              {
                on: {
                  click: function($event) {
                    return _vm.$root.$emit(
                      "show::modal",
                      "delete-my-card-modal"
                    )
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("common.card.menu.remove")))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-divider" }),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              {
                attrs: { disabled: _vm.saveDisabled },
                on: { click: _vm.openMakePublicModal }
              },
              [
                _vm.card.share_level === 2
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.$t("common.card.menu.make_public")))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.card.share_level === 1
                  ? _c("span", { staticClass: "typography--color-accent" }, [
                      _vm._v(_vm._s(_vm.$t("common.card.menu.make_private")))
                    ])
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33e0e43f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33e0e43f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/my-cards/views/MyCardDetails.vue
// module id = LSKi
// module chunks = 1